import React from 'react';
import { useTranslation } from 'react-i18next';
import IntegrationInfoAlert from '../IntegrationInfoAlert/IntegrationInfoAlert';

/**
 * Field hint with the same blue halo as section helps, without dismiss.
 */
const HelpTooltips = ({ value, children }) => {
    const { t } = useTranslation();
    const content = children ?? (value ? t(`definition.${value}`) : null);

    if (!content) {
        return null;
    }

    return (
        <IntegrationInfoAlert>
            {content}
        </IntegrationInfoAlert>
    );
};

export default HelpTooltips;
